<template>
    <div>
        <div class="pb-4">
            <b>Request Details</b>
            <p class="py-2">Shipping Reference: {{ getCreatedShipment.shippingReference || 'N/A' }}</p>
            <p>
                Package: {{ shipping.shipperlocation && shipping.shipperlocation.address ?
                    shipping.shipperlocation.address.name : 'N/A' }}
            </p>

            <section v-if="canShowMap" class="relative">
                <div class="flex py-24 bg-gray-200 flex-wrap mt-3 w-full h-full z-10" v-if="detailsLoading">
                    <div class="w-full flex justify-center">
                        <span class="loader">
                            <img src="@/assets/images/ondemand/loader.svg" /></span>
                    </div>
                    <p class="w-full text-center pt-4 px-3">
                        Searching for a dispatcher.<br />
                        Please be patient.
                    </p>
                </div>



                <div v-if="!detailsLoading" class="mt-3 rounded-2xl overflow-hidden relative">
                    <div v-if="!liveTripData?.polyline?.length"
                        class=" absolute w-full h-full justify-center items-center flex px-3 z-10">
                        Map not active, No action from dispatcher yet
                    </div>
                    <GmapMap :center="center" :zoom="14" style="width:100%; height:400px">
                        <gmap-polyline :path="polyLines" :options="polyOptions" />
                        <gmap-marker :position="origin" label="🚖" />
                        <gmap-marker :position="destination" :label="distinationLabel" />
                    </GmapMap>
                </div>

                <div>
                    <div v-if="!detailsLoading"
                        class=" bg-gray-100 mt-4 rounded p-3 flex flex-wrap justify-between items-center relative">
                        <button v-if="liveTripData?.polyline?.length" @click="showMessageModal = true" class="float_msg">
                            <span> Chat Dispatcher</span><button class="msg_icon">
                                <img src="./icons/msg-icon.svg" />
                            </button>
                        </button>
                        <div class="confirmation_detail">
                            <div class="detail_item">
                                <div class="detail_text">
                                    <span class="block w-6/12 text-gray-500">Description</span>
                                    <span class="w-6/12 flex items-center justify-end">{{ 'Parcel' }}</span>
                                </div>
                            </div>
                            <div class="detail_item">
                                <div class="detail_text">
                                    <span class="block w-6/12 text-gray-500">Receiver(s)</span>
                                    <span class="w-6/12 flex items-center justify-end text-right">{{
                                        getReceieverWithPackagesNames }}</span>
                                </div>
                            </div>
                            <div class="detail_item">
                                <div class="detail_text">
                                    <span class="block w-6/12 text-gray-500">Sender</span>
                                    <span class="w-6/12 flex items-center justify-end">
                                        {{ getCreatedShipment.shipperlocation &&
                                            getCreatedShipment.shipperlocation.contactName ?
                                            getCreatedShipment.shipperlocation.contactName : 'N/A' }}</span>
                                </div>
                            </div>
                            <div class="detail_item">
                                <div class="detail_text">
                                    <span class="block w-6/12 text-gray-500">Pick-Up Time</span>
                                    <span class="w-6/12 flex items-center justify-end">{{ liveTripData.origin
                                        ? displayPickupTime()
                                        : "N/A" }}
                                    </span>
                                </div>
                            </div>
                            <div class="detail_item">
                                <div class="detail_text">
                                    <span class="block w-6/12 text-gray-500">Estimated Drop-Off</span>
                                    <span class="w-6/12 flex items-center justify-end">{{ getDriverETA }}</span>
                                </div>
                            </div>

                        </div>
                        <span class="verical_divider"></span>
                        <div class="confirmation_detail">
                            <div class="detail_item">
                                <div class="detail_text">
                                    <span class="block w-6/12 text-gray-500">Payment</span>
                                    <span class="w-6/12 flex items-center justify-end">{{ paymentType }}</span>
                                </div>
                            </div>
                            <div class="detail_item">
                                <div class="detail_text">
                                    <span class="block w-6/12 text-gray-500">Dispatcher</span>
                                    <span class="w-6/12 flex items-center justify-end">{{ getDispatcherName }}</span>
                                </div>
                            </div>
                            <div class="detail_item">
                                <div class="detail_text">
                                    <span class="block w-6/12 text-gray-500">Phone Number</span>
                                    <span class="w-6/12 flex items-center justify-end">{{
                                        liveTripData?.driver?.mobile_no || brodcastDispatch?.user?.phone || 'N/A'
                                    }}</span>
                                </div>
                            </div>
                            <div class="detail_item">
                                <div class="detail_text">
                                    <span class="block w-6/12 text-gray-500">Fleet</span>
                                    <span class="w-6/12 flex items-center justify-end">{{ getFleetNumber }}</span>
                                </div>
                            </div>
                            <div class="detail_item">
                                <div class="detail_text">
                                    <span class="block w-6/12 text-gray-500">Status</span>
                                    <span     class="w-6/12 flex items-center justify-end capitalize" :class="[
                                        true ? statusBg(tripAccepted ? tripAccepted.status : null) : null,
                                    ]">{{ liveTripData.status
                                        ||
                                        tripAccepted.status
                                        ? liveTripData.status || tripAccepted.status
                                        : "N/A" }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <div v-if="tripCreateError" class=" flex justify-center py-8 pt-12 border border-gray-300 mt-3 rounded-2xl">
                <div class=" w-auto">
                    <div class=" w-full flex justify-center mb-3">
                        <img src="@/assets/images/delete-illustration.png" />
                    </div>
                    <p class=" text-2xl text-red-500 text-center">Error Occured</p>
                    <div class=" w-full flex justify-center">
                        <button class=" border border-gray-600 text-gray-500 px-3 py-1 rounded-2xl mt-2"
                            @click="creatTripRequest">Try Again</button>
                    </div>
                </div>
            </div>

            <div class="flex w-full items-center justify-end py-4 px-4  ">
                <button   v-if="liveTripData.status === 'accepted'"  class=" font-normal py-4 px-8  message "  @click="openMessageModal(booking[0])" >
                    Start Messaging
                </button  >
                <primary-button  v-if="liveTripData.status === 'accepted'"  class="shadow-md font-normal" buttonText="Cancel  Booking" 
                     @click="moveToHome" />
                <primary-button   v-if="liveTripData.status === 'in-transit'"   class="shadow-md font-normal" buttonText="Home" :loading="loading"
                    :disabled="isDisabled" @click="moveToHome" />
                    
            </div>

        </div>

        <ConfirmationModal v-if="canShowConfirmModal && !canShowMap" :showModal="showConfirmationModal"
            @closeModal="showConfirmationModal = false" :moveToHome="moveToHome"
            :shipingService="shipping?.shippingservice"  :shipping="shipping"/>
        <MessageModal :messageProps="messageProps" :show-modal="showMessageModal"
            @close-modal="showMessageModal = false" />
    </div>
</template>

<script>
import moment from "moment";
import SocketioService from "@/services/socketio.service";
import { onbordingtype } from '@/components/constant/onboardingType.js';
import ConfirmationModal from "./modals/confirmationModal.vue";
import MessageModal from "../Ondemand/Bookings/modals/MessageModal.vue";


export default {
    name: 'new_booking_confirmation',
    components: {
        ConfirmationModal,
        MessageModal
    },
    data() {
        return {
            mainTripId: null,
            showMessageModal: false,
            showConfirmationModal: true,
            center: {},
            path: [], // filled in mounted()
            tripCreateError: false,
            polyOptions: {
                strokeColor: 'rgb(9,183,138)',
                strokeOpacity: 0.7,
                strokeWeight: 5
            },
            lat: 3.406448,
            lng: 3.349149,
            shipping: {},
            mapLoading: false,
            detailsLoading: true,
            tripId: undefined,
            liveTripData: {},
            isLoading: false,
            tripData: {},
            interval: null,
            shippingDetails: {},
            shippingId: null,
            shipmentLoading: false,
            
                 bookings: [],
                
    //   loading: false,
    //   bookingCount: 0,
      pageSize: 10,
      pageNumber: 1,
    //   bookingValue: {},
    //   showNewBookingModal: false,
    //   bookingTotalValue: null,
      sortOptions: {
        pageSize: 10,
        pageNumber: 1,
        interval: "month",
        startDate: "2025-02-25",
        endDate: "2025-02-25",
        searchString: "",
      },
        }
    },
    created() {
        SocketioService.setupSocketConnection();
    },
    mounted() {
        if (this.$store.getters?.getselectedBroadcastDriver?.id) {
            this.detailsLoading = false
        }
    },
    computed: {
        messageProps() {
            return {
                ...this.shipping,
                driver: this.liveTripData?.driver,
                tripId: this.liveTripData?.id,
            }
        },
        brodcastDispatch() {
            return this.$store.getters?.getselectedBroadcastDriver
        },
        polyLines() {
            return (this.path || []).map((point) =>
                Array.isArray(point)
                    ? {
                        lat: Number(point[0]),
                        lng: Number(point[1]),
                    }
                    : {
                        lat: Number(point.lat),
                        lng: Number(point.lng),
                    }
            );
        },
        getReceieverWithPackagesNames() {
            const recieversWithPackag = this.$store.getters.getSavedNewRecieverPackage;
            return recieversWithPackag.map((item) => item?.name || item?.contactName).join(', ');
        },
        paymentType() {
            return this.liveTripData?.paymentType == 'cash' ? 'Pay on Delivery' : this.liveTripData?.paymentType
        },
        getRecieverInfo() {
            return `${this.liveTripData?.destination?.user?.name} (${this.liveTripData?.destination?.user?.phoneNumber})`
        },
        getFleetNumber() {
            return `${this.liveTripData?.driver?.fleet?.vehicleType || this.brodcastDispatch?.vehicletype || "N/A"} | ${this.liveTripData?.driver?.fleet?.vehicleNumber || this.brodcastDispatch?.vehicleNumber || "N/A"}`
        },
        getDispatcherName() {
            return `${this.liveTripData?.driver?.firstname || this.brodcastDispatch?.user?.firstname || 'N/A'}  ${this.liveTripData?.driver?.lastname || this.brodcastDispatch?.user?.firstname || ""}`
        },
        dist() {
            return [{ lat: 6.465422, lng: 3.406448 }, { lat: 7.53434, lng: 3.349149 }]
        },
        destinationLabel() {
            switch (this.liveTripData.status) {
                case 'accepted':
                    return this.shipping?.shipperlocation?.contactName
                case 'in-transit':
                    return this.shipping?.consigneelocation?.contactPerson

                default:
                    return ''
            }
        },
        originLabel() {
            return (this.liveTripData.status == "accepted" || this.liveTripData.status == "in-transit") ? "Driver" : ''
        },
        getCreatedShipment() {
            return this.$store.getters.getCreatedBooking;
        },
        getLoadWeight() {
            const totalWeight = (this.shippingDetails?.shipping?.shipmentReceiever || []).reduce((sum, order) => {
                const packageWeight = (order?.packagees || []).reduce((pkgSum, pkg) => {
                    return pkgSum + (Number(pkg?.estimatedWeight) * Number(pkg?.quantity || 1));
                }, 0);

                return sum + packageWeight;
            }, 0);

            return totalWeight;
        },
        formatOrderDate(val) {
            // Create a moment object with the current date and time
            const currentMoment = moment();
            if (!val) return null
            val = val.split('-')

            // Get the year, month, and date for 2024-07-02
            const year = val[0];
            const month = val[1] - 1; // Month is 0-based, so 6 represents July
            const day = val[2];

            // Set the moment object to 2024-07-02 with the current time
            const customDate = currentMoment.set({
                year: year,
                month: month,
                date: day
            });

            // Format the date to ISO 8601 with milliseconds and UTC timezone
            const formattedDate = customDate.toISOString();
            return formattedDate;
        },
        canShowMap() {
            if (this.$store.getters?.getselectedBroadcastDriver?.id) return true;
            return this.shipping.shippingMethod === "door-to-door" || (this.shipping.shippingMethod == "terminal-to-door" && !this.$store.getters.getIsInterState && this.$_3pl) && !this.tripCreateError
        },
        createTripPayload() {
            return {
                bookingChannel: "muleex",
                bookingDate: new Date(),
                loadWeight: this.getLoadWeight,
                orderDate: this.$store.getters?.getSavedNewSender?.pickUpDays,
                origin: {
                    address: this.shipping.shipperlocation
                        ? this.shipping.shipperlocation?.address?.name
                        : "N/A",
                    lat: this.shipping.shipperlocation
                        ? parseFloat(this.shipping.shipperlocation?.address?.lat)
                        : "N/A",
                    long: this.shipping.shipperlocation
                        ? parseFloat(this.shipping.shipperlocation.address.lng)
                        : "N/A",
                    user: {
                        name: this.shipping.shipperlocation
                            ? this.shipping?.shipperlocation?.contactName ||
                            this.shipping?.shipperlocation?.contactPerson
                            : "N/A",
                        phoneNumber: this.shipping.shipperlocation
                            ? this.shipping.shipperlocation.mobile
                            : "N/A",
                        email: this.shipping.shipperlocation
                            ? this.shipping.shipperlocation.email
                            : "N/A",
                    },
                },
                tripCost: this.idD2Tinterstate ? Number(this.shippingDetails?.firstMileShipment?.transaction?.totalValue) : Number(this.shipping?.transaction?.totalValue),
                shippingId: this.tripId,
                status: "pending",
                paymentType: this.$store.getters.getNewBookingpaymenttype.toLowerCase(),
                vehicleType: "Bike"
            }
        },
        getDriverETA() {
            const { origin, destination, driver, status } = this.liveTripData
            const destLat = status == 'accepted' ? origin?.lat : destination?.lat;
            const destLong = status == 'accepted' ? origin?.long : destination?.long;
            const driverLat = driver?.location?.latitude || 0;
            const driverLong = driver?.location?.longitude || 0;

            let Eta = this.getETA(driverLat, driverLong, destLat, destLong, 40)
            return Eta
        },
        idD2Tinterstate() {
            const shippingmethod = this.$store.getters.getNewBookingShippingMethod;
            const isInterstate = this.$store.getters.getIsInterState;
            return isInterstate && shippingmethod === "door-to-door"
        },
        canShowConfirmModal() {
            return this.$store.getters.getNewBookingShippingMethod !== "door-to-door" && !this.shipmentLoading
        }
    },
    activated() {
        this.getShipping();
        this.geolocate();
    },
    watch: {
         'liveTripData.status'(newStatus, oldStatus) {
            if (newStatus === 'accepted' && oldStatus !== 'accepted') {
                this.getAllBookings();
            }
        },
        //  payload() {
        //         this.getAllBookings();
        //     },
        center: {
            handler() {
                // Do not auto focus, manage map bounds manually
                this.updateMapBounds();
            },
            deep: true
        },
        shippingId(val) {
            if (!this.canShowMap) return;

            this.socketEventName = val;

            this.interval = setInterval(() => {
                SocketioService.tripInfo(val).then((data) => {
                    const polyline = data.polyline || data?.info?.polyline || [];
                    console.log(data)
                    const first = polyline[0];
                    const last = polyline[polyline.length - 1];

                    this.liveTripData = data;
                    this.detailsLoading = false;
                    this.path = Array.isArray(polyline) ? polyline : [];

                    this.center = this.origin = first
                        ? Array.isArray(first)
                            ? {
                                lat: Number(first[0]),
                                lng: Number(first[1]),
                            }
                            : {
                                lat: Number(first.lat),
                                lng: Number(first.lng),
                            }
                        : {};

                    this.destination = last
                        ? Array.isArray(last)
                            ? {
                                lat: Number(last[0]),
                                lng: Number(last[1]),
                            }
                            : {
                                lat: Number(last.lat),
                                lng: Number(last.lng),
                            }
                        : {};

                    this.isLoading = false;
                }).catch(() => {
                    this.path = [];
                    this.center = {};
                    this.origin = {};
                    this.destination = {};
                    this.isLoading = false;
                    this.detailsLoading = false;
                });
            }, 1000);
        },
    },
    methods: {
         openMessageModal(val) {
            this.$store.dispatch("saveNewCurrentShipping", val);
            this.showMessageModal = true;
        },
        statusBg(val) {
            let bg = "";
            switch (val) {
                case "paid":
                    bg = "text-red-500";
                    break;

                case "pending":
                    bg = "text-primary-yellow";
                    break;

                case "in-transit":
                    bg = "text-primary-yellow";
                    break;

                case 'accepted':
                    bg = "text-teal-500";
                    break;
                case 'Picked_up':
                    bg = "text-teal-500";
                    break;

                default:
                    bg = "text-teal-500";
                    break;
            }
            return bg;
        },
        getETA(driverLat, driverLong, destLat, destLong, averageSpeedKmh) {
            if (
                driverLat == null || driverLong == null ||
                destLat == null || destLong == null
            ) {
                return null;
            }

            averageSpeedKmh = averageSpeedKmh || 40;

            const toRad = function (value) {
                return value * Math.PI / 180;
            };

            const R = 6371; // Earth radius in km
            const dLat = toRad(destLat - driverLat);
            const dLon = toRad(destLong - driverLong);
            const a =
                Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.cos(toRad(driverLat)) * Math.cos(toRad(destLat)) *
                Math.sin(dLon / 2) * Math.sin(dLon / 2);

            const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            const distanceKm = R * c;

            const etaMinutes = Math.round((distanceKm / averageSpeedKmh) * 60);

            if (etaMinutes < 1) return "less than a minute";
            if (etaMinutes < 60) return etaMinutes + " min" + (etaMinutes > 1 ? "s" : "");

            const days = Math.floor(etaMinutes / (60 * 24));
            const hours = Math.floor((etaMinutes % (60 * 24)) / 60);
            const minutes = etaMinutes % 60;

            const parts = [];
            if (days > 0) parts.push(days + " day" + (days > 1 ? "s" : ""));
            if (hours > 0) parts.push(hours + " hour" + (hours > 1 ? "s" : ""));
            if (minutes > 0) parts.push(minutes + " min" + (minutes > 1 ? "s" : ""));

            return parts.join(" ");
        },
        getETAInSecs(driverLat, driverLong, destLat, destLong, averageSpeedKmh) {
            if (
                driverLat == null || driverLong == null ||
                destLat == null || destLong == null
            ) {
                return null;
            }

            averageSpeedKmh = averageSpeedKmh || 40;

            const toRad = function (value) {
                return value * Math.PI / 180;
            };

            const R = 6371; // Earth radius in km
            const dLat = toRad(destLat - driverLat);
            const dLon = toRad(destLong - driverLong);
            const a =
                Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.cos(toRad(driverLat)) * Math.cos(toRad(destLat)) *
                Math.sin(dLon / 2) * Math.sin(dLon / 2);

            const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            const distanceKm = R * c;

            const etaMinutes = Math.round((distanceKm / averageSpeedKmh) * 60);

            return etaMinutes
        },
        updateMapBounds() {
            if (this.map && this.center[0] && this.center[1]) {
                const bounds = new window.google.maps.LatLngBounds();
                bounds.extend(new window.google.maps.LatLng(this.center[0].lat, this.center[0].lng));
                bounds.extend(new window.google.maps.LatLng(this.center[1].lat, this.center[1].lng));
                this.map.fitBounds(bounds);
            }
        },
        displayPickupTime() {
            // Input iOS date string            
            const iosDateString = this.liveTripData?.orign?.departure_time;

            // Parse the iOS date string using Moment.js
            const iosDate = moment(iosDateString);

            // Add 900 seconds
            const newIosDate = iosDate.add(this.getETAInSecs() || 0, "seconds");

            // Format the new date as "YYYY-MM-DD, hh:mm"
            const formattedDate = newIosDate.format("YYYY-MM-DD, hh:mm");
            return formattedDate;
        },
        async tripAccepted(val) {
            this.tripData = val;
        },
        async getAllBookings() {
            this.loading = true;
            try {
                const response = await this.$_getActiveBookings(this.payload);
                // this.allbookings = response.data.data
                this.bookings = response.data.data.allShippings;
                // this.bookingCount = response.data.data?.totalCount ?? "0";
                // this.bookingTotalValue = response.data.data?.totalTransactionValue ?? "0";
            } catch (error) {
                this.handleError(error);
            }
            this.loading = false;
        },
       
        setPlace(val) {
            console.log(val);
        },
        goBack() {
            this.$store.dispatch('setSavedActiveTab', 3)
        },
        moveToHome() {
            this.is3Pl = this.$store.getters.user.onboardingtype.toLowerCase() == onbordingtype.MULEEX_3PL;
            const routeTo = this.is3Pl ? "/3pl/dashboard" : "/active-bookings"
            this.$router.push(routeTo)
        },
        geolocate: function () {
            this.origin = {
                lat: Number(this.shipping.shipperlocation?.address.lat ?? 0),
                lng: Number(this.shipping.shipperlocation?.address.lng ?? 0),
            };
        },
        async getShipping() {
            this.shipmentLoading = true;
            try {
                const response = await this.$_getCreatedNewBooking(this.getCreatedShipment?.id);
                this.shipping = response.data.data.shipping;
                this.shippingId = this.idD2Tinterstate ? response.data.data?.firstMileShipment?.id : response.data.data?.shipping?.id;
                this.shippingDetails = response.data.data;
                this.tripId = this.idD2Tinterstate ? response.data.data?.firstMileShipment?.id : response.data.data?.shipping?.id;

                this.center = [
                    {
                        lat: this.shipping.shipperlocation?.address.lat || 0,
                        lng: this.shipping.shipperlocation?.address.lng || 0,
                    },
                    {
                        lat: this.shipping.consigneelocation?.address.lat || 0,
                        lng: this.shipping.consigneelocation?.address.lng || 0,
                    },
                ];

                if (
                    this.shipping.shippingMethod == "door-to-door"
                ) {
                    (await this.creatTripRequest());
                }
                if (this.shipping.tripId) {
                    this.load = true;
                    // this.isLoading = false;
                    // this.tripId = this.shipping.tripId
                }
            } catch (error) {
                //
            } finally {
                this.shipmentLoading = false;
            }
        },
        async creatTripRequest() {
            this.tripCreateError = false;
            this.isLoading = true;

            try {
                await this.$apollo
                    .mutate({
                        mutation: this.$_GraphQL_Endpoint.getDispatchDriver,
                        variables: {
                            newTripData: this.createTripPayload,
                        },
                    })
                    .then((res) => {
                        this.tripId = res?.data?.createTrip?.trip?.id;
                        this.mainTripId = res?.data?.createTrip?.trip?.id;
                        this.tripObj = res?.data?.createTrip?.trip
                        if (
                            res?.data?.createTrip?.trip?.status == "in-transit" ||
                            res?.data?.createTrip?.trip?.status == "accepted" ||
                            (res?.data?.createTrip?.trip?.status == "pending" && !this.checkIfBookinIsNow)
                        ) {
                            this.isLoading = false;
                        }
                        if (res.message == "No drivers available") {
                            this.generateToast(res.message, "error");
                        }
                    });
            } catch (error) {
                clearInterval(this.interval);
                this.tripCreateError = true
            }
        },
    },
    beforeDestroy() {
        SocketioService.disconnect();
        clearInterval(this.interval);
        this.$store.dispatch("resetState");
    },
}
</script>

<style lang="scss" scoped>
.float_msg {
    @apply items-center inline-flex gap-2 bg-primary-lightblue p-1 px-1.5 pl-1.5 rounded-full absolute -top-[2rem] right-0 border-primary-palegrey border-[1px] text-sm;

    span {
        display: none;
    }

    &:hover span {
        display: inline-block
    }
}

.msg_icon {
    @apply w-[37px] h-[37px] rounded-full justify-center items-center bg-primary-yellow inline-flex;

    img {
        @apply w-[22px] h-[22px]
    }
}

.loader {
    display: inline-block;
    width: auto;
    height: auto;
    animation: 2s infinite linear rolls;
}

@keyframes rolls {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}

.confirmation_detail {
    @apply md:w-[48%] w-full
}

.detail_text {
    @apply flex pb-0 items-center;
}

.detail_item {
    @apply mt-2 pb-1 text-base;
}

.verical_divider {
    @apply w-[1px] bg-gray-400 h-[180px] block;
}

.terminal_container {
    @apply py-8
}
button{
    background: #FFFFFF; 
    font-weight: 700; 
}

</style>